import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authApi, setToken } from '@/lib/api/client';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code) {
      navigate('/login');
      return;
    }

    const handleAuth = async () => {
      try {
        if (state === 'login') {
          const response = await authApi.githubLogin(code);
          setToken(response.access_token);
          navigate('/');
        } else if (state === 'bind') {
          await authApi.bindGithub(code);
          navigate('/'); // Ideally show a success toast
        } else {
            // Default fallback if state is missing?
            navigate('/login');
        }
      } catch (error) {
        console.error('GitHub Auth Error:', error);
        navigate('/login?error=github_auth_failed');
      }
    };

    handleAuth();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">{t('index.loading')}</h2>
        <p className="text-slate-500">Processing GitHub authentication...</p>
      </div>
    </div>
  );
}
